import React from 'react'
import { StyledTextAreaLabelWrapper, StyledTextAreaLabel, StyledTextArea, StyledTextAreaError } from './styled'

const TextArea = ({ label, name, placeholder, value, error, disabled, onChange }) => {
    return (
        <StyledTextAreaLabelWrapper>
            {
                label &&
                <StyledTextAreaLabel>{label}</StyledTextAreaLabel>
            }
            <StyledTextArea
                name={name}
                placeholder={placeholder}
                value={value}
                error={error}
                disabled={disabled}
                onChange={onChange}
            />
            {
                error &&
                <StyledTextAreaError>{error}</StyledTextAreaError>
            }
        </StyledTextAreaLabelWrapper>
    )
}

export default TextArea